import { http, ep } from "../../client/http";

export const serviceRegionRepo = {
  get: async () => {
    const res = await http.get(ep("serviceRegion/list?limit=1000"), {
      params: { status: true },
    });
    return res.data.data;
  },
};
